var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComparisonReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16050",
    "data-name": "Group 16050",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.913,
    height: 29.468,
    viewBox: "0 0 41.913 29.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8397",
    "data-name": "Rectangle 8397",
    width: 41.913,
    height: 29.468,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16049",
    "data-name": "Group 16049",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5836",
    "data-name": "Path 5836",
    d: "M54.826,0a.775.775,0,0,0-.776.776V13.185a.774.774,0,0,0,.776.771H67.235a.773.773,0,0,0,.771-.771A13.2,13.2,0,0,0,54.826,0",
    transform: "translate(-26.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5837",
    "data-name": "Path 5837",
    d: "M38.039,18.4H26.406V6.776A.775.775,0,0,0,25.63,6a13.091,13.091,0,0,0-6.223,1.562,13.182,13.182,0,1,0,0,23.24A13.183,13.183,0,0,0,38.815,19.18a.775.775,0,0,0-.776-.776M24.854,7.572v5.493a13.086,13.086,0,0,0-2.555-3.4,12.222,12.222,0,0,0-1.216-1.035c-.047-.036-.093-.067-.14-.1a11.608,11.608,0,0,1,3.91-.957M17.913,29.861a11.568,11.568,0,0,1-4.733,1A11.682,11.682,0,1,1,17.907,8.5a11.336,11.336,0,0,1,1.541.833c.155.093.305.2.45.3a10.519,10.519,0,0,1,1.216.983,11.615,11.615,0,0,1,3.74,8.147v.419a.214.214,0,0,0,.01.083,11.68,11.68,0,0,1-4.96,9.471c-.15.1-.3.207-.455.3a10.709,10.709,0,0,1-1.536.828m7.717.952a11.589,11.589,0,0,1-4.686-.983c.047-.031.093-.062.14-.1A12.171,12.171,0,0,0,22.3,28.7a13.136,13.136,0,0,0,4.04-8.747h10.9A11.652,11.652,0,0,1,25.63,30.813",
    transform: "translate(0 -2.896)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonReportIcon);
export default __webpack_public_path__ + "static/media/comparison-report-icon.d59681ae6c5695d6ad4d15619757df44.svg";
export { ForwardRef as ReactComponent };